import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";


import { useSessionLibrary } from "~/modules/main/hooks/use-session-library/use-session-library";

import { useTranscript } from "~/modules/main/hooks/use-transcript/use-transcript";


/**
 * Domain hook implementations
 * 
 * This is a collection of all the domain hooks that are available in the application.
 * It is used to provide the domain hooks to the application.
 * 
 * You can access them by using the `useDomainHooks` hook.
 */
export const domainHooksRegistry: DomainHooksRegistryInterface = {

    useSessionLibrary: useSessionLibrary,

    useTranscript: useTranscript,

} as DomainHooksRegistryInterface;